export default __webpack_public_path__ + "static/media/social-media-bg-g.f773bd2c.png";